import Crud from '@/views/Alocation/Crud'
import Add from '@/views/Alocation/Add'

const routes = {
  path: '/alocations',
  component: resolve => require(['../layouts/full/LayoutFull'], resolve),
  children: [
    {
      path: '/alocations',
      name: 'list-alocations',
      component: Crud,
    },
    {
      path: '/alocations/add',
      name: 'Alocação',
      component: Add,
    },
    {
      path: '/alocations/edit/:id?',
      name: 'Alocação',
      component: Add,
    },
  ],
}

export default routes
